import React from "react";
import "animate.css";
function OrderFulfilment() {
  return (
    <div className="animate__animated animate__zoomIn">
      <div className="container  w-4/5  mx-auto  px-4 my-28">
        <div className="grid grid-cols-2 gap-20 font-Montserrat">
          <div className="md:flex md:flex-col content-start  justify-items-start">
            <h2 className="text-blue-200 text-2xl font-bold">
              Order Fulfillment
            </h2>
            <p>
              orem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into
            </p>
            <button className="bg-blue-200 px-2 py-4 text-white rounded-md w-40 mt-8 hover:bg-blue-100 font-semibold">
              Start free trial
            </button>
          </div>
          <div className="md:flex md:flex-col content-start  justify-items-start">
            <div>
              <img
                src="https://media.istockphoto.com/photos/stormy-weather-picture-id109718219?b=1&k=20&m=109718219&s=170667a&w=0&h=7k9qX9R44r8ffAjsyp_cXu6-SInLf7ZjuMB51Taw9lw="
                alt="Logo"
                className="h-80 shadow-2xl rounded-sm absolute "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrderFulfilment;
